import { useMemo } from "react"
import type { CombinedError, OperationContext } from "urql"
import { useQuery } from "urql"

import type { Query, User, UserGetSuccess } from "@/graphql/codegen/graphql"
import { UserDetailsDocument } from "@/graphql/codegen/graphql"

export const useGetUser = (
  userId: string
): {
  user: User
  fetching: boolean
  error: CombinedError | undefined
  reexecuteQuery: (opts?: Partial<OperationContext>) => void
} => {
  const [{ data, fetching, error }, reexecuteQuery] = useQuery<Pick<Query, "user">>({
    query: UserDetailsDocument,
    variables: { input: { userId } },
  })

  const user = useMemo(() => (data?.user?.get as UserGetSuccess)?.user, [data])

  return {
    user,
    fetching,
    error,
    reexecuteQuery,
  }
}
